import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import { NuDsContext } from '@nubank/nuds-web/components/NuDSProvider/NuDSProvider';

import AdvantagesListRoot from './styles/AdvantagesListRoot';
import AdvantagesListItemRoot from './styles/AdvantagesListItemRoot';
import AdvantagesListItemBullet from './styles/AdvantagesListItemBullet';

function AdvantagesList({ index }) {
  const { formatMessage } = useContext(NuDsContext);
  const advantages = formatMessage({ id: `cms.businessAccountPage.cardsArea[${index}].advantage` });
  return (
    <AdvantagesListRoot role="list">
      {advantages.map(({ id }, advantageIndex) => <AdvantagesListItem key={id} intlKey={`cms.businessAccountPage.cardsArea[${index}].advantage[${advantageIndex}].title`} />)}
    </AdvantagesListRoot>
  );
}

function AdvantagesListItem({ intlKey }) {
  return (
    <AdvantagesListItemRoot>
      <AdvantagesListItemBullet
        ariaHidden="true"
        name="arrow-down-right"
      />
      <Typography
        variant="paragraph2"
        intlKey={intlKey}
      />
    </AdvantagesListItemRoot>
  );
}

AdvantagesListItem.propTypes = {
  intlKey: PropTypes.string.isRequired,
};

AdvantagesList.propTypes = {
  index: PropTypes.number.isRequired,
};

export default React.memo(AdvantagesList);
